import { Component, Input, OnInit } from '@angular/core';
import { JobPointeService } from 'src/app/service/job-pointe/job-pointe.service';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { JobBoardService } from '../service/job-board.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-job-card-list',
  templateUrl: './job-card-list.component.html',
  styleUrls: ['./job-card-list.component.scss'],
  animations: [
    trigger('openClose', [
      state(
        'open',
        style({
          opacity: 1,
          display: 'block',
        }),
      ),
      state(
        'closed',
        style({
          opacity: 0,
          display: 'none',
        }),
      ),
      transition('open => closed', [animate('0.25s')]),
      transition('closed => open', [animate('0.5s')]),
    ]),
  ],
})
export class JobCardListComponent implements OnInit {
  @Input() id!: string;
  @Input() tab: string;
  @Input() jobBoardCardData: any;
  staticData: any = {};
  constructor(
    private jobPointeService: JobPointeService,
    private jobBoardService: JobBoardService,
  ) { }
  empSideBarSubscription: Subscription;
  jobSideBarSubscription: Subscription;
  isSideNavOpen: boolean = false;
  isEmployeeSideNavOpen: boolean = false;
  cardSideNavData: any;
  cardType: any;
  employeeCardSideNavData: any;
  jobBoardTagAssignments: Array<any> = [];
  tagAssignments: Array<any> = [];

  ngOnInit() {
    this.staticData.foremanList = this.getForemanList();
    this.empSideBarSubscription = this.jobBoardService.employeeSideBarOpenSource.subscribe(data => {
      this.onOpenEmployeeSideNav(data);
    });
    this.jobSideBarSubscription = this.jobBoardService.jobSideBarOpenSource.subscribe(data => {
      this.onOpenJobSideNav(data);
    });
    this.closeSideNavBar(false);
  }

  ngOnDestroy() {
    this.empSideBarSubscription.unsubscribe();
    this.jobSideBarSubscription.unsubscribe();
  }

  getForemanList() {
    return new Promise((resolve) => {
      this.jobPointeService.read['manageForeman']({}).subscribe(res => {
        resolve(
          res.data
            .map(f => ({
              id: f.id,
              name: f?.employeeAlias ? f.employeeAlias : `${f.firstName} ${f.lastName}`,
              phone: f.phone,
            }))
            .sort((a, b) => a.name.localeCompare(b.name)),
        );
      });
    });
  }

  objectKeys = data => (data ? Object.keys(data).sort() : []);

  mapTagAssignment(data, shouldGetFacilityOrJobCerts = false) {
    if (shouldGetFacilityOrJobCerts) {

      if (!data?.id) return

      const facilityId = data.id

      this.jobPointeService.read['facilityAttributes']({ facilityId }).subscribe(res => {
        this.cardSideNavData.jobBoardAttributes = res.data.jobBoardAttributes
      })
    }

    this.jobPointeService.read['jobBoardTagAssignments']({}).subscribe(res => {
      this.jobBoardTagAssignments = res.data;
      if (data && this.cardSideNavData) {
        this.tagAssignments = this.jobBoardTagAssignments.filter(
          ta => (ta.facilityId || ta.jobId) == this.cardSideNavData?.id,
        );
      } else if (data && this.employeeCardSideNavData) {
        this.tagAssignments = this.jobBoardTagAssignments.filter(ta => ta.userId == this.employeeCardSideNavData?.id);
      } else {
        this.tagAssignments = [];
      }
    });
  }

  onOpenJobSideNav(data: any) {
    this.cardSideNavData = data;
    this.cardType = data;
    this.mapTagAssignment(data, true);
    this.isEmployeeSideNavOpen = false;
    this.employeeCardSideNavData = null;
    this.isSideNavOpen = true;
  }

  onOpenEmployeeSideNav(data: any) {
    if (data) {
      this.employeeCardSideNavData = data;
      this.mapTagAssignment(data);
      this.isSideNavOpen = false;
      this.cardSideNavData = null;
      this.isEmployeeSideNavOpen = true;
    } else {
      this.isEmployeeSideNavOpen = false;
      this.employeeCardSideNavData = null;
    }
  }

  closeSideNavBar(event) {
    this.cardSideNavData = null;
    this.cardType = null;
    this.isSideNavOpen = event;
  }

  closeEmployeeSideNavBar(event) {
    this.employeeCardSideNavData = null;
    this.isEmployeeSideNavOpen = event;
  }

  trackByGroupBy(index: number, item: string): string {
    return item;
  }

  trackByCardId(index: number, item: any): number {
    return item.id;
  }
}
